import { Post, User } from "../../../Utilities";
import { MediaAttachmentFormValues } from "../MediaAttachment";
import { SharingRecordCustomFormValues } from "../SharingRecord";

export type Base = {
	title: Post["title"];
	body: Post["body"];
};

export type Create = Base & {
	mediaAttachments: MediaAttachmentFormValues.CreateInPost[];
	sharingRecord: SharingRecordCustomFormValues.CreateInParent[];
};

export type CreateRequiredKey = Extract<keyof Create, never>;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	title: "",
	body: "",
	mediaAttachments: [],
	sharingRecord: [SharingRecordCustomFormValues.blankItemInParent],
};

export type Detail = Base & {
	createdAt: Post["createdAt"] | null;
	authorID: User["id"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;
